export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";